import { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';

type Props = {
  label?: string;
  disabled?: boolean;
  onDownload: () => Promise<void>;
};

export function ReportDownloadPdfButton({
  label = 'Download PDF',
  disabled = false,
  onDownload,
}: Props) {
  const [busy, setBusy] = useState(false);

  const handleClick = async () => {
    setBusy(true);
    try {
      await onDownload();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      variant="contained"
      color="primary"
      disabled={disabled || busy}
      startIcon={busy ? <CircularProgress size={18} color="inherit" /> : <PictureAsPdfOutlinedIcon />}
      onClick={handleClick}
      sx={{
        borderRadius: '12px',
        textTransform: 'none',
        fontWeight: 600,
        px: 2.5,
      }}
    >
      {label}
    </Button>
  );
}
